import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.sidebar = document.getElementById("AiSidebar")
    this.scrollToBottomBtn = document.getElementById("scroll-to-bottom-btn")
    this.updateVisibility()
  }

  updateVisibility() {
    const sidebarIsVisible = this.sidebar?.classList.contains("d-flex") || this.sidebar?.classList.contains("d-lg-flex")

    if (sidebarIsVisible) {
      this.buttonTarget.classList.add("d-none")
      this.sidebar.classList.add("open")
      this.sidebar.classList.remove("closed")
      this.scrollToBottomBtn?.classList.remove("d-none")
    } else {
      this.buttonTarget.classList.remove("d-none")
      this.buttonTarget.classList.remove("d-inline-block")
      this.sidebar.classList.add("closed")
      this.sidebar.classList.remove("open")
      this.scrollToBottomBtn?.classList.add("d-none")
    }
  }

  toggleSidebar() {
    if (!this.sidebar) return

    if (this.sidebar.classList.contains("d-lg-flex")) {
      this.sidebar.classList.remove("d-lg-flex")
    }

    this.sidebar.classList.toggle("d-flex")
    this.updateVisibility()
  }
}
